import React from 'react';
import {
    DialogTitle,
    DialogDescription,
    Dialog,
    DialogContent,
    DialogHeader,
} from '~/primitives/dialog';

interface InfoModalProps {
    isOpen: boolean;
    onClose: () => void;
    infoType: string;
}

export const PartnerDialog: React.FC<InfoModalProps> = ({
    isOpen,
    infoType,
    onClose,
}) => {
    const renderContent = () => {
        switch (infoType) {
            case 'IDL':
                return (
                    <>
                        <DialogTitle>Insane Demon List</DialogTitle>
                        <DialogDescription className="py-4">
                            The IDL (Insane Demon List) is a GD List that aims
                            to rank the top 150 Insane Demons by difficulty. You
                            can find more information on{' '}
                            <strong>
                                <a
                                    target="_blank"
                                    href="https://insanedemonlist.com/"
                                    className="font-bold underline hover:text-primary transition-colors"
                                    rel="noreferrer"
                                >
                                    their website
                                </a>
                            </strong>
                            !
                        </DialogDescription>
                    </>
                );
            case 'NLW':
                return (
                    <>
                        <DialogTitle>Non List Worthy Spreadsheet</DialogTitle>
                        <DialogDescription className="py-4">
                            The NLW (Non List Worthy) Spreadsheet is an Extreme
                            Demon resource that categorizes every single rated
                            extreme demon not placed on Pointercrate into
                            different tiers with difficulties, such as Beginner,
                            Easy, etc. You can find more information on{' '}
                            <strong>
                                <a
                                    target="_blank"
                                    href="https://docs.google.com/spreadsheets/d/1YxUE2kkvhT2E6AjnkvTf-o8iu_shSLbuFkEFcZOvieA/"
                                    className="font-bold underline hover:text-primary transition-colors"
                                    rel="noreferrer"
                                >
                                    their spreadsheet
                                </a>
                            </strong>
                            !
                        </DialogDescription>
                    </>
                );
            case '2PL':
                return (
                    <>
                        <DialogTitle>2 Player List</DialogTitle>
                        <DialogDescription className="py-4">
                            This list keeps track of the hardest 2-player levels
                            in Geometry Dash that have been done solo. Levels
                            must have enough of it’s length or difficulty come
                            from it’s 2p sections to place on the list. You can
                            find more information on{' '}
                            <strong>
                                <a
                                    target="_blank"
                                    href="https://2plist.github.io/2plist/#/"
                                    className="font-bold underline hover:text-primary transition-colors"
                                    rel="noreferrer"
                                >
                                    their website
                                </a>
                            </strong>
                            !
                        </DialogDescription>
                    </>
                );
            case 'UDL':
                return (
                    <>
                        <DialogTitle>Unrated Demons List</DialogTitle>
                        <DialogDescription className="py-4">
                            The UDL (Unrated Demons List) ranks the top 200
                            unrated demons in Geometry Dash by difficulty. You
                            can find more information on{' '}
                            <strong>
                                <a
                                    target="_blank"
                                    href="https://udl.pages.dev/"
                                    className="font-bold underline hover:text-primary transition-colors"
                                    rel="noreferrer"
                                >
                                    their website
                                </a>
                            </strong>{' '}
                            or join their{' '}
                            <strong>
                                <a
                                    target="_blank"
                                    href="https://discord.gg/Uj8m4rr8WA"
                                    className="font-bold underline hover:text-primary transition-colors"
                                    rel="noreferrer"
                                >
                                    Discord server
                                </a>
                            </strong>
                            !
                        </DialogDescription>
                    </>
                );
            case 'EDEL':
                return (
                    <>
                        <DialogTitle>Extreme Demon Enjoyments List</DialogTitle>
                        <DialogDescription className="py-4">
                            The EDEL (Extreme Demon Enjoyments List) is an
                            Extreme Demon resource with over 50,000 enjoyment
                            ratings. Check out{' '}
                            <strong>
                                <a
                                    target="_blank"
                                    href="https://docs.google.com/spreadsheets/d/1-2-n2aU__rQya_IESevHjEU0f1xbegKUZEslk7fV38Q/"
                                    className="font-bold underline hover:text-primary transition-colors"
                                    rel="noreferrer"
                                >
                                    their spreadsheet
                                </a>
                            </strong>{' '}
                            for more information and submit your own ratings!
                        </DialogDescription>
                    </>
                );
            case 'EDEL_PENDING':
                return (
                    <>
                        <DialogTitle>Unreliable Rating</DialogTitle>
                        <DialogDescription className="py-4">
                            This level has limited enjoyments. Help improve its
                            accuracy by submitting your ratings on the{' '}
                            <strong>
                                <a
                                    target="_blank"
                                    href="https://discord.gg/pdeZY2FU3U"
                                    className="font-bold underline hover:text-primary transition-colors"
                                    rel="noreferrer"
                                >
                                    EDEL Discord
                                </a>
                            </strong>
                            !
                        </DialogDescription>
                    </>
                );
            case 'SFH':
                return (
                    <>
                        <DialogTitle>Song File Hub</DialogTitle>
                        <DialogDescription className="py-4">
                            SFH (Song File Hub) lets you search, find, and
                            download NONGs or mashups for any GD level. You can
                            find more information on{' '}
                            <strong>
                                <a
                                    target="_blank"
                                    href="https://songfilehub.com/home"
                                    className="font-bold underline hover:text-primary transition-colors"
                                    rel="noreferrer"
                                >
                                    their website
                                </a>
                            </strong>
                            !
                        </DialogDescription>
                    </>
                );
            case 'PEMONLIST':
                return (
                    <>
                        <DialogTitle>Pemonlist</DialogTitle>
                        <DialogDescription className="py-4">
                            The Pemonlist ranks platformer demons up to 150
                            levels and includes level packs. You can find more
                            information on{' '}
                            <strong>
                                <a
                                    target="_blank"
                                    href="https://pemonlist.com/"
                                    className="font-bold underline hover:text-primary transition-colors"
                                    rel="noreferrer"
                                >
                                    their website
                                </a>
                            </strong>
                            !
                        </DialogDescription>
                    </>
                );
            case 'GDDL':
                return (
                    <>
                        <DialogTitle>Geometry Dash Demon Ladder</DialogTitle>
                        <DialogDescription className="py-4">
                            The GDDL provides a tier-based ranking system for
                            demon levels to improve efficiently. You can find
                            more information on{' '}
                            <strong>
                                <a
                                    target="_blank"
                                    href="https://gdladder.com"
                                    className="font-bold underline hover:text-primary transition-colors"
                                    rel="noreferrer"
                                >
                                    their website
                                </a>
                            </strong>
                            !
                        </DialogDescription>
                    </>
                );
            case 'TSL':
                return (
                    <>
                        <DialogTitle>The Shitty List</DialogTitle>
                        <DialogDescription className="py-4">
                            The Shitty List is a collection of levels which have
                            a 1.0 aesthetic, with the aim of making some of the
                            hardest and most inaccessible levels more accessible
                            to a less-skilled playerbase. You can find more
                            information on{' '}
                            <strong>
                                <a
                                    target="_blank"
                                    href="https://tsl.pages.dev"
                                    className="font-bold underline hover:text-primary transition-colors"
                                    rel="noreferrer"
                                >
                                    their website
                                </a>
                            </strong>
                            !
                        </DialogDescription>
                    </>
                );
            case 'GSV':
                return (
                    <>
                        <DialogTitle>Global Stats Viewer</DialogTitle>
                        <DialogDescription className="py-4">
                            Global Stats Viewer aims to be a stats viewer that
                            unites major demon lists such as Pointercrate and
                            AREDL with Geometry Dash itself. Any rated level
                            completion contributes to a higher score. This
                            website is good for those who want a ranking formula
                            that measures skill while not being restricted to
                            only the 150 hardest demons. Many features are
                            planned to be added in the future, with more
                            partnerships planned including with the GD World
                            Tournament, Insane Demon List, and more. You can
                            find more information on{' '}
                            <strong>
                                <a
                                    target="_blank"
                                    href="https://globalstatsviewer.com/"
                                    className="font-bold underline hover:text-primary transition-colors"
                                    rel="noreferrer"
                                >
                                    their website
                                </a>
                            </strong>
                            !
                        </DialogDescription>
                    </>
                );
            default:
                return (
                    <>
                        <DialogTitle>Unknown Partner</DialogTitle>
                        <DialogDescription className="py-4">
                            No information is available for this partner.
                        </DialogDescription>
                    </>
                );
        }
    };

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="max-w-2xl">
                <DialogHeader>{renderContent()}</DialogHeader>
            </DialogContent>
        </Dialog>
    );
};
